import { BN } from "@polkadot/util";
import BigNumber from "bignumber.js";

const ROUNDING_MODE = BigNumber.ROUND_DOWN;
const DECIMAL_PLACES = 2;
const FORMAT: BigNumber.Format = {
  prefix: "",
  decimalSeparator: ".",
  groupSeparator: ",",
  groupSize: 3,
  secondaryGroupSize: 0,
  fractionGroupSeparator: " ",
  fractionGroupSize: 0,
  suffix: "",
};

/**
 * @deprecated use formatBigNumber from packages/utils/src/format/numbers.ts instead
 * @param bn
 * @param opts
 */
export const formatBigNumber = (
  bn: BigNumber,
  opts?: { dp?: number; rm?: BigNumber.RoundingMode; fmt?: BigNumber.Format },
) =>
  bn
    .dp(opts?.dp ?? DECIMAL_PLACES, opts?.rm ?? ROUNDING_MODE)
    .toFormat(opts?.fmt ?? FORMAT);

// TODO move to @equilab/utils
export const formatBn = (
  bn: BN,
  precision: number = 9,
  opts?: { dp?: number; rm?: BigNumber.RoundingMode; fmt?: BigNumber.Format },
) =>
  formatBigNumber(
    new BigNumber(bn.toString(10)).div(
      new BigNumber(10).exponentiatedBy(precision),
    ),
    { dp: 4, ...opts },
  );

export const formatNum = (
  num: string | number | BigNumber | undefined,
  opts?: {
    dp?: number;
    rm?: BigNumber.RoundingMode;
    fmt?: BigNumber.Format;
    emptyVal?: string;
    prefix?: string;
    postfix?: string;
  },
) => {
  const isBn = BigNumber.isBigNumber(num);

  if (typeof num !== "number" && typeof num !== "string" && !isBn) {
    return opts?.emptyVal ?? "-";
  }

  const bn = isBn ? num : new BigNumber(num);

  if (bn.isNaN() || !bn.isFinite()) return opts?.emptyVal ?? "-";

  return `${opts?.prefix ?? ""}${formatBigNumber(bn, opts)}${
    opts?.postfix ?? ""
  }`;
};

export const trimNumber = (
  val: string,
  limitInteger: number = 12,
  limitDecimals: number = 9,
) => {
  let i = 0;
  const v = val.replace(" ", "");

  const removeDots = v.replace(/[.%]/g, function (match) {
    return match === "." ? (i++ === 0 ? "." : "") : "";
  });

  let [ip, dp] = removeDots.split(".");

  if (dp && dp.length > limitDecimals) {
    dp = dp.substring(0, limitDecimals);
    return `${ip}.${dp}`;
  }

  if (ip && ip.length > limitInteger) {
    ip = ip.slice(0, limitInteger);
    return `${ip}${v.includes(".") ? `.${dp ?? ""}` : ""}`;
  }
  return v;
};

export const FORMAT_NO_GROUP_SEPARATOR: BigNumber.Format = {
  prefix: "",
  decimalSeparator: ".",
  groupSeparator: "",
  groupSize: 3,
  secondaryGroupSize: 0,
  fractionGroupSeparator: " ",
  fractionGroupSize: 0,
  suffix: "",
};
